import styled from 'styled-components';
import { IRadioProps } from '../../../types/formTypes';

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioLine = styled.div<IRadioProps>`
  display: grid;
  gap: 20px;
  grid-template-columns: 1.15em 1fr;
  user-select: none;
  cursor: pointer;
  color: black;

  &:focus {
    outline: none;
  }

  input[type='radio'] {
    cursor: pointer;
    appearance: none;
    background-color: #ffffff00;
    margin: 0;
    color: black;
    width: 20px;
    height: 20px;
    border: 1px solid black;
    border-radius: 50%;
    position: relative;
    place-content: center;
    display: block;
  }

  input[type='radio']::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ffffff00;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  input[type='radio']:checked::before {
    background-color: black;
  }
`;

export const RadioError = styled.div<IRadioProps>`
  color: var(--base-color-errorstate);
`;
